<div
  class="content"
  (click)="$event.stopPropagation();"
>
  <div class="thumb-row">
    <h2>{{title}}</h2>
    <mojo-thumb
      [type]="thumbIcon"
      [selected]="true"
      [raisedOnSelected]="raisedThumbButton"
    ></mojo-thumb>
  </div>

  <div
    *ngIf="menuType === TAGS_MENU || menuType === TEXT_AREA_TAGS"
    class="reasons-panel"
  >
    <div
      class="reason font-regular"
      [ngClass]="{'selected': tag.selected}"
      (click)="reasonSetSelected(i, true)"
      *ngFor="let tag of reasonTags; let i = index"
    >
      <span>{{tag.text}}</span>
      <mat-icon
        *ngIf="tag.selected"
        (click)="reasonSetSelected(i, false); $event.stopPropagation()"
      >cancel</mat-icon>
    </div>
  </div>

  <div
    *ngIf="menuType === TEXT_AREA_MENU || menuType === TEXT_AREA_TAGS"
    class="reasons-text-area"
  >
    <form [formGroup]="form">
      <mojo-editor
        formControlName="note"
        maxLength="1000"
        [showUserMentionTags]="true"
        [showCandidateMentionTags]="true"
        toolbar=""
        placeholder="Share your thoughts on this candidate with recruiters"
      ></mojo-editor>
    </form>
  </div>

  <div class="button-row">
    <button
      mat-flat-button
      color="primary"
      class="md"
      [disabled]="validForm()"
      (click)="onSendMatchReasons()"
    >{{getButtonText()}}</button>
  </div>
</div>
